import { useCallback } from "react";

import {
  EntityColumnCustomizationSource,
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { useWorkspaceContext } from "src/router/routerContextHooks";

/**
 * Tracks adoption of per-user column customization (reordering columns and
 * hiding/showing fields) on entity tables. `source` distinguishes the surface
 * the customization happened on.
 */
export const useTrackEntityColumnCustomization = (
  entitySchemaType: string,
  source: EntityColumnCustomizationSource,
) => {
  const { orgId, workspace } = useWorkspaceContext();
  const workspaceId = workspace.id;

  const trackColumnsReordered = useCallback(() => {
    tracker.emit(
      trackingEvents.entityColumnsReordered({
        organization_id: orgId,
        workspace_id: workspaceId,
        entity_schema_type: entitySchemaType,
        source,
      }),
    );
  }, [orgId, workspaceId, entitySchemaType, source]);

  const trackFieldVisibilityChanged = useCallback(
    (field: string, hidden: boolean) => {
      tracker.emit(
        trackingEvents.entityFieldVisibilityChanged({
          organization_id: orgId,
          workspace_id: workspaceId,
          entity_schema_type: entitySchemaType,
          source,
          field,
          hidden,
        }),
      );
    },
    [orgId, workspaceId, entitySchemaType, source],
  );

  return { trackColumnsReordered, trackFieldVisibilityChanged };
};
